export default "__VITE_ASSET__942dd7da__"